// extracted by mini-css-extract-plugin
export default {"container":"style_container__AxZDl","autoScroll":"style_autoScroll__5agBJ","buttonWrapper":"style_buttonWrapper__NKWrv"};